/* eslint 'no-self-assign' : 'off', eqeqeq : 'off', react/no-direct-mutation-state: "off"  */
import React, {Component} from 'react';
import { Form, FormGroup, Col, Label } from 'reactstrap';
import {MdSave} from 'react-icons/md';
import {Icon} from 'semantic-ui-react';
import {connect} from 'react-redux';
import DraggableList from './DraggableList';
import { AddPreventativeMaintenanceCustomField,OpenAddCustomPopup,UpdatePMCustomField,DeletePMCustomFieldValues } from 'action/workorderAction';

let CustomFieldName = "Custom Field";

const headinglabel = {
    fontfamily: 'Lato',
    fontSize: '14px',
    fontWeight: 'bold'
};

const ErrorSign = {
    color: '#D42D27',
    paddingLeft: '8px',
    paddingTop: '0px',
    paddingRight: '14px',
    width: '22px',
    height: '22px',
    top: '406px',
    left: '959px'
};

const ErrorPadding = {
    'color': '#D42D27',
    'font-family': 'Lato',
    'font-style': 'italic',
    'border': '2px solid #D42D27',
    'height': '40px',
    'padding': '10px',
    'float': 'left',
    'background-color': '#FFFFFF',
    'font-size': '13px',
    'margin-bottom': '0px',
    'margin-top': '3px'
};

class AddEditPMCustomFieldSetup extends Component{

    constructor(props){
        super(props);
        this.state = {
            data:{
                Field:'',
                FieldLabel: '',
                FieldId: 0,
                FieldType: 0,
                Value: [],
                Display: true,
                Required: false,
                selectedForSort:'',
            },
            IsFieldLabelError: false,
            ErrorMsg: '',
            isTextType: true,
            dropdowndata: [],
            deletedList:[],
            warning:false,
            IsError: false,
            IsValidationError: false,
            Error:'',
            FieldName: null,
            IsFieldValueError: false
        };
        this.FieldTypeChange = this.FieldTypeChange.bind(this);
        this.AddValues = this.AddValues.bind(this);
        this.DeleteValue = this.DeleteValue.bind(this);
        this.OptionChanged = this.OptionChanged.bind(this);
        this.Sort = this.Sort.bind(this);
        this.OnAddEditCustomField = this.OnAddEditCustomField.bind(this);
        this.CloseAddCustomField = this.CloseAddCustomField.bind(this);
        this.MoveUp = this.MoveUp.bind(this);
        this.MoveDown = this.MoveDown.bind(this);
        this.ClosePopup = this.ClosePopup.bind(this);
         this.SetSelection = this.SetSelection.bind(this);
    }

    componentWillMount(){
        var scrollPageTop = (this.props.Premise) ? document.getElementsByClassName('Ensemble_Content_FullPage') : document.getElementsByClassName('Ensemble_Content');
        if(scrollPageTop[0] !== undefined){
            (this.props.Premise) ? scrollPageTop[0].scrollIntoView() : scrollPageTop[0].scrollTop = 0;
        }
    }

    componentWillUnmount(){
        this.props.AddEditCustomtoggle(false,null);
    }

    FieldTypeChange(){
        if(this.refs.FieldType_Text.checked)
            this.setState({isTextType : true});
        else{
             var Data = {
                field: "Optional",
                fieldLabel: "Optional",
                fieldId: 0,
                type: "Dropdown, Single",
                value: [],
                shortValue: "",
                display: true,
                required: false,
            }
            this.setState({isTextType : false, dropdowndata : Data});
        }
    }

    AddValues(saving_data,saving_data_actual){
        this.setState({
            dropdowndata:saving_data, data:saving_data_actual
        });
    }

    ClosePopup(){
        this.setState({warning:false});
    }

    DeleteValue(saving_data_actual, added_options, deltedList, IsExists) {
        if (!IsExists) {
            this.setState({ dropdowndata: saving_data_actual, data: added_options, deletedList: deltedList});
        }
        else
        {
            this.setState({warning:!this.state.warning});
        }
    }

    OptionChanged(added_options, saving_data) {
        this.setState({
            data: added_options, dropdowndata: saving_data
        });
    }

    Sort(saving_data, added_options)
    {
        this.setState({ 
            dropdowndata: saving_data, data: added_options 
        });
    }

    async OnAddEditCustomField(){
        let IsValid = true;
        var RegexRestrictSpecialCharacter =/^[a-zA-Z0-9 ]*$/;
        let l_FieldLabel = this.refs.text_fieldlabel.value;
        this.setState({IsError:false, ErrorMsg: '', IsFieldLabelError:false, IsValidationError:false,IsFieldValueError: false});
        if(!!l_FieldLabel === false || !l_FieldLabel.match(RegexRestrictSpecialCharacter)){
            IsValid = false;
            this.setState({IsError:true, ErrorMsg: !!l_FieldLabel === false ? "An entry is required" : "Enter valid input", IsFieldLabelError:true});
        }

        if (this.props.CustomFieldId !== undefined && this.props.CustomFieldId !== -1)
        {
            if(this.state.data.fieldType === 1 && this.state.data.value.length === 0)
            {
                IsValid = false;
                this.setState({IsError:true, ErrorMsg: "An entry is required",IsFieldValueError:true});
            }
        }

        else if(this.refs.FieldType_Text !== undefined && Number(!this.refs.FieldType_Text.checked) === 1 && this.state.data.Value.length === 0)
        {
            IsValid = false;
            this.setState({IsError:true, ErrorMsg: "An entry is required",IsFieldValueError:true});
        }



        if (this.props.getCustomFields !== undefined && this.props.getCustomFields !== null && this.props.getCustomFields.length) {
            let lstFields = this.props.getCustomFields;            
            lstFields = lstFields.filter(function (item) {
                return l_FieldLabel.toUpperCase() === item.fieldLabel.toUpperCase()
            });
            if(this.props.CustomFieldId === undefined || this.props.CustomFieldId === -1){
                if (lstFields !== null && lstFields.length > 0) {
                    if (lstFields[0].fieldLabel !== null) {
                        IsValid = false;
                        this.setState({IsError:true, ErrorMsg: this.props.getLabels['WorkOrderSetup.Custom.DuplicateValidation.Text'], IsFieldLabelError:true });
                    }
                }
            }
            else{

            if (lstFields !== null && lstFields.length > 0) {
                if (lstFields !== null && lstFields.length > 0) {
                    if (lstFields[0].fieldLabel !== this.state.FieldName) {
                        IsValid = false;
                        this.setState({IsError:true, ErrorMsg: this.props.getLabels['WorkOrderSetup.Custom.DuplicateValidation.Text'], IsFieldLabelError:true });
                    }
                }
            }
            }
        }
        if (this.props.getStandardFields !== undefined && this.props.getStandardFields !== null && this.props.getStandardFields.length) {
            var fieldsFromDB = this.props.getStandardFields;
            fieldsFromDB.forEach(fields => {
                fields.fieldLabel = (fields.fieldLabel !== "") ? fields.fieldLabel : this.props.getLabels['PreventativeMaintenance.Options.' + fields.fieldId + '.Text'];
            });
            var lstFields = fieldsFromDB.filter(function (item) {
                return l_FieldLabel.toUpperCase() === item.fieldLabel.toUpperCase()
            });
            if (lstFields !== null && lstFields.length > 0) {
                if (lstFields[0].fieldLabel !== null) {
                    IsValid = false;
                    this.setState({IsError:true, ErrorMsg: this.props.getLabels['WorkOrderSetup.Custom.DuplicateValidation.Text'], IsFieldLabelError:true });
                }
            }
        }
        if (this.refs.required_Yes.checked && !this.refs.display_Yes.checked) {
            IsValid = false;
            this.setState({IsError:true, Error: this.props.getLabels['SetupValidationError.Text'], IsValidationError:true});
        }
        if(IsValid) {
            var saving_data;
            if (this.props.CustomFieldId !== undefined && this.props.CustomFieldId !== -1){
                saving_data= this.state.data;
                saving_data.FieldId = this.props.CustomFieldId;
                saving_data.FieldName = CustomFieldName;
                saving_data.FieldLabel = this.refs.text_fieldlabel.value;
               
                saving_data.FieldType = this.state.dropdowndata.fieldType;
                saving_data.Required = this.refs.required_Yes.checked;
                saving_data.Display = this.refs.display_Yes.checked;
                
                this.props.UpdatePMCustomField(saving_data,this.props.CustomFieldId);
                if (this.state.deletedList.length > 0){
                    this.props.DeletePMCustomFieldValues(this.state.deletedList, this.props.CustomFieldId)
                }    
                this.props.OpenAddCustomPopup(false,-1);
                this.setState({IsError:false});
            }

           else{
            saving_data = this.state.data;
            saving_data.FieldId = 0;
            saving_data.FieldName = CustomFieldName;
            saving_data.FieldLabel = this.refs.text_fieldlabel.value;
            saving_data.FieldType = Number(!this.refs.FieldType_Text.checked);
            saving_data.Required = this.refs.required_Yes.checked;
            saving_data.Display = this.refs.display_Yes.checked;
            
            this.props.AddPreventativeMaintenanceCustomField(saving_data);
            this.props.OpenAddCustomPopup(false,-1);
            this.setState({IsError:false});
           }
        }
    }

    CloseAddCustomField(){
        this.props.OpenAddCustomPopup(false,-1);
    }

    MoveDown(){
        if (this.state.selectedForSort != undefined) {
            var saving_data = this.state.dropdowndata;
            var index_Array = saving_data.value.map(el => (
                parseInt(el.orderId)
            ));
            var added_options = [];

            var selectedvalue_orderId = saving_data.value.filter(x => x.index == this.state.selectedForSort)[0].orderId;
            if (selectedvalue_orderId < Math.max(...index_Array)) {
                var next_index = saving_data.value.filter(x => x.orderId == selectedvalue_orderId + 1)[0].index;
                saving_data.value.forEach(el => {
                    if (el.index == this.state.selectedForSort) {
                        el.orderId = selectedvalue_orderId + 1;
                        added_options = this.AddToSaveList(selectedvalue_orderId + 1, el);
                    }
                    if (el.index == next_index) {
                        el.orderId = selectedvalue_orderId;
                        added_options = this.AddToSaveList(selectedvalue_orderId, el);
                    }
                });
                this.setState({ dropdowndata: saving_data, data: added_options });
            }
        }
    }

    MoveUp() {
        if (this.state.selectedForSort != undefined) {
            var saving_data = this.state.dropdowndata;
            var added_options = [];
            var selectedvalue_orderId = saving_data.value.filter(x => x.index == this.state.selectedForSort)[0].orderId;
            if (selectedvalue_orderId > 0) {
                var next_index = saving_data.value.filter(x => x.orderId == selectedvalue_orderId - 1)[0].index;
                saving_data.value.forEach(el => {
                    if (el.index == this.state.selectedForSort) {
                        el.orderId = selectedvalue_orderId - 1;
                        added_options = this.AddToSaveList(selectedvalue_orderId - 1, el);
                    }
                    if (el.index == next_index) {
                        el.orderId = selectedvalue_orderId;
                        added_options = this.AddToSaveList(selectedvalue_orderId, el);
                    }
                });
                this.setState({ dropdowndata: saving_data, data: added_options });
            }
        }
    }

    AddToSaveList = (order, row) =>
    {
        var added_options = this.state.data;
        if (added_options.Value.filter(x => x.index == row.index).length > 0) {
            added_options.Value.forEach(element => {
                if (element.index == row.index) {
                    element.orderId = order;
                }
            });
        }
        else {
            var lineitem = {
                "key": row.key,
                "value": row.value,
                "isCustom": row.isCustom,
                "index":row.index,
                "orderId":order
            }
            added_options.Value.push(lineitem);
        }
        return added_options;
    }

    SetSelection(index) {
        this.setState({ selectedForSort: index });
    }

    render(){
        let label = this.props.getLabels;  
        var FType, FRequired, FDisplay;
        let fieldLabel,fieldType, required, display , HeaderLabel;

        var errormsg ='';
        if(this.state.IsError){
            errormsg = <p style={ErrorPadding} ><Icon name='exclamation triangle' style={ErrorSign} /><b> {(!this.state.IsValidationError ? "Please correct all errors before continuing.": this.state.Error)}</b></p> 
        }   

        if(this.state.dropdowndata.length && this.state.dropdowndata.value !== "--")
        {
            const sortedData = this.state.dropdowndata.value.sort((a, b) => {
                var nameA = a['orderId'];
                var nameB = b['orderId'];

                if (nameA < nameB) {
                    return -1;
                }
                if (nameA > nameB) {
                    return 1;
                }
                if (nameA == nameB) {
                    return 0;
                }
                return 0;
            });
            // eslint-disable-next-line react/no-direct-mutation-state
            this.state.dropdowndata.value = sortedData;
        }

        if (this.props.CustomFieldId !== undefined && this.props.CustomFieldId !== -1) {
            var l_CustFieldID = this.props.CustomFieldId;
            var data = this.props.getCustomFields;
            //Header Label in Edit mode
            HeaderLabel = <div>
                <Label style={headinglabel}>{label['WorkOrderSetup.Custom.Edit.Text'] !== undefined ? label['WorkOrderSetup.Custom.Edit.Text'] : "Edit Custom Field"}</Label>
            </div>
            if (data !== null && data.length > 0) {

                var l_row = data.filter(x => x.fieldId == l_CustFieldID)[0];
                var l_rowValue = [];
                if (l_row.value != "--" && l_row.value != undefined) {
                    l_rowValue = l_row.value.map((el, i) => ({
                        key: el.key,
                        value: el.value,
                        isCustom: true,
                        index: i,
                        orderId: el.orderId
                    }));
                    l_row.value = l_rowValue;
                    
                }

                fieldLabel = l_row.fieldLabel;
                fieldType = l_row.fieldType;
                required = l_row.required;
                display = l_row.display;
                this.state.FieldName = l_row.fieldLabel;
                //Field Type in Edit mode
                FType = (fieldType === 0) ? <Label>&nbsp;{label['WorkOrderSetup.Custom.Textbox.Text'] !== undefined ? label['WorkOrderSetup.Custom.Textbox.Text'] : "Text Box"}</Label> : <Label>&nbsp;{label['WorkOrderSetup.Custom.Dropdown.Text'] !== undefined ? label['WorkOrderSetup.Custom.Dropdown.Text'] : "Dropdown, Single Selection" }</Label>
                //Field Required in Edit mode
                FRequired = (required === true) ? <div> <input type='radio' ref='required_No'  name='Required' /><Label>&nbsp;{label['WorkOrderSetup.No.Text']}</Label><br />
                    <input type='radio' ref='required_Yes' defaultChecked={true} name='Required' /><Label>&nbsp;{label['WorkOrderSetup.Yes.Text']}</Label>
                </div> : 
                <div> <input type='radio' ref='required_No' defaultChecked={true} name='Required' /><Label>&nbsp;{label['WorkOrderSetup.No.Text']}</Label><br />
                        <input type='radio' ref='required_Yes' name='Required' /><Label>&nbsp;{label['WorkOrderSetup.Yes.Text']}</Label>
                    </div>
                //Display in Edit mode
                FDisplay = (display === true) ? <div><input type='radio' ref='display_No' name='displayOnPage' /><Label>&nbsp;{label['WorkOrderSetup.No.Text']}</Label><br/>
                <input type='radio' ref='display_Yes' defaultChecked={true} name='displayOnPage' /><Label>&nbsp;{label['WorkOrderSetup.Yes.Text']}</Label></div> 
                : <div><input type='radio' ref='display_No' defaultChecked={true} name='displayOnPage' /><Label>&nbsp;{label['WorkOrderSetup.No.Text']}</Label><br/>
                <input type='radio' ref='display_Yes' name='displayOnPage' /><Label>&nbsp;{label['WorkOrderSetup.Yes.Text']}</Label></div>
                if(fieldType === 1){
                    
                    this.state.isTextType = false;
                     //Sorting based on OrderID
                    const sortedData1 = l_row.value.sort((a, b) => {
                        var nameA = a['orderId'];
                        var nameB = b['orderId'];
        
                        if (nameA < nameB) {
                            return -1;
                        }
                        if (nameA > nameB) {
                            return 1;
                        }
                        if (nameA == nameB) {
                            return 0;
                        }
                        return 0;
                    });
                    
                    l_row.value = sortedData1;
                    
                    this.state.dropdowndata = l_row;
                }
                else{
                this.state.isTextType = true;                
                }

                this.state.data = l_row;
  
            }

        }
        else {
            // Header label in Create Mode
            HeaderLabel = <div>
            <Label style={headinglabel}>{label['WorkOrderSetup.Custom.Create.Text'] !== undefined ? label['WorkOrderSetup.Custom.Create.Text'] : "Create Custom Field" }</Label>
            </div>
             //Field Type in Create mode
            FType = <div><input type='radio' ref='FieldType_Text' onChange={this.FieldTypeChange} defaultChecked={true} name='FieldType' /><Label>&nbsp;{label['WorkOrderSetup.Custom.Textbox.Text'] !== undefined ? label['WorkOrderSetup.Custom.Textbox.Text'] : "Text Box" }</Label><br/>
                    <input type='radio' ref='FieldType_Ddl' onChange={this.FieldTypeChange} name='FieldType'/><Label>&nbsp;{label['WorkOrderSetup.Custom.Dropdown.Text'] !== undefined ? label['WorkOrderSetup.Custom.Dropdown.Text'] : "Dropdown, Single Selection"}</Label>
            </div>
             //Field Type in Create mode
            FRequired = <div> <input type='radio' ref='required_No' defaultChecked={true} name='Required' /><Label>&nbsp;{label['WorkOrderSetup.No.Text']}</Label><br/>
            <input type='radio' ref='required_Yes' name='Required' /><Label>&nbsp;{label['WorkOrderSetup.Yes.Text']}</Label>
            </div>
            //Display in Create mode
            FDisplay = <div><input type='radio' ref='display_No' name='displayOnPage' /><Label>&nbsp;{label['WorkOrderSetup.No.Text']}</Label><br/>
            <input type='radio' ref='display_Yes' defaultChecked={true} name='displayOnPage' /><Label>&nbsp;{label['WorkOrderSetup.Yes.Text']}</Label></div>
        }



        return (
            <div className="main_container">
                <Form>
                    <FormGroup row>
                        <Col sm={{size:12}}>
                            {errormsg}
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Col sm={{size:12}}>
                        {HeaderLabel}
                        <div style={{float: 'right'}}>
                            <table>
                                <tr>
                                    <td><div className="workorderbtn-save" style={{"margin-left":"10px"}} onClick={this.OnAddEditCustomField} ><MdSave style={{width: '15px', height: '15px'}} /> SAVE</div></td>
                                    <td><div className="workorderbtn-cancel" style={{"margin-left":"10px"}} onClick={this.CloseAddCustomField} > CANCEL</div></td>
                                </tr>
                            </table>
                        </div>
                        </Col>
                    </FormGroup>
                    <hr style={{backgroundColor:'#666666',height:'1px',border:'none'}}/>
                    <FormGroup row style={{marginBottom:'3px'}}>
                        <Col sm={{ size:4}}>
                            <Label style={headinglabel}>{label['WorkOrderSetup.FieldName.Text']}</Label><br/>
                            <Label>{CustomFieldName}</Label><br/>
                        </Col> 
                    </FormGroup>
                    <br/>
                    <FormGroup row>
                        <Col sm={{ size: 4 }}>
                            <Label className={(this.state.IsFieldLabelError) ? "errortext" :""} style={headinglabel}>{label['WorkOrderSetup.FieldLabel.Text'] + "*"}</Label><br/>
                            <input type="text" maxLength="50" className={(this.state.IsFieldLabelError) ? "errorhighlight wo_setup_fieldvalue" : "wo_setup_fieldvalue"} ref='text_fieldlabel' defaultValue={fieldLabel} />
                            <span hidden={!this.state.IsFieldLabelError}><Icon name='exclamation triangle' style={ErrorSign} />
                                {(this.state.IsFieldLabelError)? <Label className="wo_employee_errortext" style={{display:"block", marginBottom:"0px"}}>{this.state.ErrorMsg}</Label> : ""}
                            </span>
                        </Col> 
                    </FormGroup>
                    <br/>
                    <FormGroup row style={{marginBottom:'25px'}}>
                            <Col sm={{ size: 4 }}>
                                <Label style={headinglabel}>{label['WorkOrderSetup.Custom.FieldType.Text'] !== undefined ? label['WorkOrderSetup.Custom.FieldType.Text'] : "Field Type" + (!this.state.isTextType ? "*" : "")}</Label><br />
                                {FType}
                            </Col> 
                    </FormGroup>
                    <FormGroup row>
                        <Col sm={{ size: 4 }}>
                        <Label style={headinglabel}>{label['WorkOrderSetup.Values.Text'] + (!this.state.isTextType ? "*" : "")}</Label>
                        <span hidden={!this.state.IsFieldValueError}><Icon name='exclamation triangle' style={ErrorSign} />
                            {(this.state.IsFieldValueError)? <Label className="wo_employee_errortext" style={{marginBottom:"0px",paddingLeft:"3px"}}>{this.state.ErrorMsg}</Label> : ""}
                        </span>
                        <br/>
                            {!this.state.isTextType ?
                            <DraggableList options={this.state.dropdowndata} AddOptions={this.AddValues} DeleteOptions={this.DeleteValue} UpdateOptions={this.OptionChanged} SortOptions={this.Sort} id="0" fromWorkOrder={true} /> : "--"}
                        </Col> 
                    </FormGroup>
                    <br/>
                    <FormGroup row style={{marginBottom:'25px'}}>
                        <Col sm={{ size: 4 }}>
                            <Label style={headinglabel}>{label['WorkOrders.Heading.Required.Text'] + "*"}</Label><br/>
                           {FRequired}
                        </Col> 
                    </FormGroup>
                    <FormGroup row>
                        <Col sm={{ size: 4 }}>
                            <Label style={headinglabel}>{label['WorkOrderSetup.DisplayOnPage.Text'] + "*"}</Label><br/>
                            {FDisplay}
                        </Col> 
                    </FormGroup>
                </Form>
                <div className="workorderlbl-noentry">*required fields </div> 
            </div>
            );
    }
};

const mapStateToProps = state => {
    return {
        getLabels: state.CulturalLabelsRootReducer.WorkOrderResource_LabelsBasedOnPreference,
        getCustomFields: state.WorkorderRootReducer.PreventativeMaintenanceCustomFields,
        getStandardFields : state.WorkorderRootReducer.PreventativeMaintenanceStandardFields,
    }
};

const mapDispatchToProps = dispatch => {
    return {
        AddPreventativeMaintenanceCustomField: (data) => dispatch(AddPreventativeMaintenanceCustomField(data)),
        OpenAddCustomPopup: (data,fieldId) => dispatch(OpenAddCustomPopup(data,fieldId)),
        UpdatePMCustomField: (data,FieldId) => dispatch(UpdatePMCustomField(data,FieldId)),
        DeletePMCustomFieldValues: (data,FieldId) => dispatch(DeletePMCustomFieldValues(data,FieldId)),
    }
};

export default connect(mapStateToProps,mapDispatchToProps) (AddEditPMCustomFieldSetup);